import React from "react";

import { BrandLockup } from "../BrandLockup";
import { depoimentos, depoimentosSecao } from "../../../utils/copy";
import fotoCilene from "../../../assets/images/ConversasTerapeuticas/depoimento-cilene.jpg";
import fotoBruna from "../../../assets/images/ConversasTerapeuticas/depoimento-bruna.jpg";
import fotoJessica from "../../../assets/images/ConversasTerapeuticas/depoimento-jessica.jpg";

const fotos = [fotoCilene, fotoBruna, fotoJessica];

export function Depoimentos() {
  return (
    <section id="depoimentos" data-bg="#f3e7db" className="poster-section testimonials-section">
      <BrandLockup />
      <h2 data-motion="title" className="type-display">
        {depoimentosSecao.tituloLinha1}
        <br />
        {depoimentosSecao.tituloLinha2}
      </h2>
      <p data-motion="lead" className="type-voice testimonials-note">
        {depoimentosSecao.subtitulo}
      </p>

      {/* role=list/listitem fica: o tabIndex saiu junto com o carrossel horizontal
          que existia aqui no mobile; sem rolagem, era só uma parada de tabulação
          sem destino. */}
      <div data-motion-list className="testimonials-grid" role="list" aria-label="Depoimentos de participantes do Conversas Terapêuticas">
        {depoimentos.map((depoimento, index) => (
          <div key={depoimento.quem} role="listitem">
            <div className="testimonial-photo">
              <img
                src={fotos[index]}
                alt={`Foto de ${depoimento.quem}`}
                className="h-full w-full object-cover"
              />
            </div>
            <div className="testimonial-copy">
              <p className="type-display">{depoimento.texto}</p>
              <i aria-hidden="true" />
              <p className="type-display mt-6">{depoimento.quem}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
